<template>
  <base-modal
    ref="modal"
    class="modal-auto-height transfer-modal text-left"
    :show-close-button="false"
    size="auto"
    :title="null"
    @submit="onSubmit"
  >
    <template #content>
      <h2>
        GoogleMaps Credentials
      </h2>
      <p v-html="description"></p>
      <div>
        <text-input
          id="key"
          v-model:value="key"
          label="Key"
          :min-width="300"
          placeholder="key"
          :required="true"
          type="password"
        />
      </div>
    </template>
    <template #actions>
      <base-button
        :min-width="94"
        size="l"
        @click.prevent="modal.close"
      >
        {{ cancelButton }}
      </base-button>
      <primary-button
        :min-width="114"
        size="l"
        @click.prevent="onSubmit"
      >
        {{ actionButton }}
      </primary-button>
    </template>
  </base-modal>
</template>

<script>
import { GoogleMapsRoutes } from "../../../api/routes"

export default {
  props: {
    description: {
      type: String,
      default: "Enter GoogleMaps credentials"
    },
    cancelButton: {
      type: String,
      default: "Cancel"
    },
    actionButton: {
      type: String,
      default: "Save"
    },
    successMessage: {
      type: String,
      default: "Successfully added GoogleMaps credentials"
    },
    companyUuid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      modal: {
        close: () => {}
      },
      key: ""
    }
  },
  mounted () {
    this.modal = this.$refs.modal
  },
  methods: {
    onSubmit () {
      const url = GoogleMapsRoutes.saveGoogleMapsCredentials(this.companyUuid)
      this.$apiClient.post(url, { key: this.key }).then(() => {
        this.$toasted.success(this.successMessage)
      }).finally(() => {
        this.modal.close()
      })
    }
  }
}
</script>
